import React from 'react';
import { Checkbox, Tooltip } from '@hose/eui';
import { OutlinedTipsMaybe } from '@hose/eui-icons';
export var SubCollectionTip = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, subIncludeStr = _a.subIncludeStr, includeChildrenToolTipStr = _a.includeChildrenToolTipStr, tooltipIconStyle = _a.tooltipIconStyle, _b = _a.wrapperStyle, wrapperStyle = _b === void 0 ? {} : _b, disabled = _a.disabled;
    return (React.createElement("div", { style: wrapperStyle },
        React.createElement(Checkbox, { checked: checked, onChange: onChange, disabled: disabled }, subIncludeStr),
        React.createElement(Tooltip, { overlayInnerStyle: { width: 290 }, title: includeChildrenToolTipStr },
            React.createElement(OutlinedTipsMaybe, { style: tooltipIconStyle }))));
};
export default SubCollectionTip;
